export const MAX_INPUT_CHARACTERS = 15;
export const EMPTY_IMAGE = 'EMPTY';
export const NOTIFICATION_DURATION = 3000;
export const NOTIFICATION_TRANSITION_DURATION = 600; // as long as animation duration in css
export const RESPONSE_THROTTLE_TIME = 500;
